import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { CheckCircle, Package, ArrowRight, Home } from 'lucide-react';
import HeaderOne from '../components/HeaderOne';
import FooterOne from '../components/FooterOne';

const OrderSuccessPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [orderInfo, setOrderInfo] = useState(null);

    useEffect(() => {
        // If there's no state from the checkout page, maybe redirect to home
        // For now, we'll just show a generic success if no state is passed
        if (location.state && location.state.orders) {
            setOrderInfo(location.state);
        }
    }, [location.state]);

    return (
        <>
            <HeaderOne />
            <div className="order-success-container">
                <div className="success-card">
                    <div className="success-icon-wrapper">
                        <CheckCircle size={64} className="success-icon" />
                    </div>
                    
                    <h1 className="success-title">Order Placed Successfully! 🎉</h1>
                    <p className="success-subtitle">
                        Thank you for your purchase. We've received your order and are getting it ready for shipment.
                    </p>

                    {orderInfo && orderInfo.orders && (
                        <div className="order-details-summary">
                            <p><strong>Order Reference:</strong> #{orderInfo.orders[0]._id?.slice(-8).toUpperCase() || 'P-100'}</p>
                            <p><strong>Payment Method:</strong> {orderInfo.paymentMethod}</p>
                            <p className="delivery-estimate">
                                <Package size={16} />
                                Estimated Delivery: 3-5 Business Days
                            </p>
                        </div>
                    )}

                    <div className="success-actions">
                        <Link to="/customer/dashboard" className="btn-primary">
                            View Order Status
                            <ArrowRight size={18} />
                        </Link>
                        <Link to="/" className="btn-secondary">
                            <Home size={18} />
                            Continue Shopping
                        </Link>
                    </div>
                </div>
            </div>

            <style>{`
                .order-success-container {
                    min-height: 70vh;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 40px 20px;
                    background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
                }
                .success-card {
                    background: white;
                    padding: 48px;
                    border-radius: 24px;
                    box-shadow: 0 20px 40px rgba(16, 185, 129, 0.1);
                    text-align: center;
                    max-width: 500px;
                    width: 100%;
                    animation: scaleUp 0.5s cubic-bezier(0.16, 1, 0.3, 1);
                }
                .success-icon-wrapper {
                    width: 96px;
                    height: 96px;
                    background: #d1fae5;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin: 0 auto 24px;
                    animation: bounceIn 0.8s cubic-bezier(0.16, 1, 0.3, 1) 0.2s both;
                }
                .success-icon {
                    color: #10b981;
                }
                .success-title {
                    font-size: 28px;
                    font-weight: 700;
                    color: #064e3b;
                    margin-bottom: 12px;
                }
                .success-subtitle {
                    color: #475569;
                    font-size: 15px;
                    line-height: 1.6;
                    margin-bottom: 32px;
                }
                .order-details-summary {
                    background: #f8fafc;
                    padding: 20px;
                    border-radius: 12px;
                    margin-bottom: 32px;
                    text-align: left;
                    border: 1px solid #e2e8f0;
                }
                .order-details-summary p {
                    margin: 8px 0;
                    color: #334155;
                    font-size: 14px;
                }
                .delivery-estimate {
                    display: flex;
                    align-items: center;
                    gap: 8px;
                    color: #10b981 !important;
                    font-weight: 500;
                    margin-top: 16px !important;
                    padding-top: 16px;
                    border-top: 1px dashed #cbd5e1;
                }
                .success-actions {
                    display: flex;
                    flex-direction: column;
                    gap: 16px;
                }
                .btn-primary, .btn-secondary {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 8px;
                    padding: 14px 24px;
                    border-radius: 12px;
                    font-weight: 600;
                    font-size: 16px;
                    text-decoration: none;
                    transition: all 0.3s ease;
                }
                .btn-primary {
                    background: #10b981;
                    color: white;
                    box-shadow: 0 4px 12px rgba(16, 185, 129, 0.2);
                }
                .btn-primary:hover {
                    background: #059669;
                    transform: translateY(-2px);
                    box-shadow: 0 6px 16px rgba(16, 185, 129, 0.3);
                }
                .btn-secondary {
                    background: white;
                    color: #475569;
                    border: 1px solid #cbd5e1;
                }
                .btn-secondary:hover {
                    background: #f1f5f9;
                    color: #1e293b;
                }
                @keyframes scaleUp {
                    from { transform: scale(0.9); opacity: 0; }
                    to { transform: scale(1); opacity: 1; }
                }
                @keyframes bounceIn {
                    0% { transform: scale(0); }
                    50% { transform: scale(1.2); }
                    100% { transform: scale(1); }
                }
            `}</style>
        </>
    );
};

export default OrderSuccessPage;
